import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import GlobalStyle from './styles/global';
import Routex from './routes';
import AppProvider from './hooks';
import { PreviousURLProvider } from './hooks/previousLink';
import OnboardingController from './components/Onboarding/OnboardingController';
import { OnboardingProvider } from './hooks/onboarding';
import OnboardingManager from './components/Onboarding/OnboardingManager';
import ErrorBoundary from './components/ErrorBoundary';
import RouteErrorBoundary from './components/ErrorBoundary/RouteErrorBoundary';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const Wrapper: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <PreviousURLProvider>
        <Wrapper>
          <OnboardingProvider>
            {/*
              Envolve só as rotas: toasts, modais e GlobalStyle seguem vivos,
              e o boundary se recupera sozinho ao navegar.
            */}
            <RouteErrorBoundary>
              <Routex />
            </RouteErrorBoundary>
            {/* Onboarding é decorativo: se quebrar, falha em silêncio. */}
            <ErrorBoundary fallback={null}>
              <OnboardingManager />
              <OnboardingController />
            </ErrorBoundary>
          </OnboardingProvider>
        </Wrapper>
      </PreviousURLProvider>
      <GlobalStyle />
    </AppProvider>
  );
};

export default App;
